var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCpra24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lm-Icon",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H6C2.685 6 0 8.685 0 12C0 15.315 2.685 18 6 18H18C21.315 18 24 15.315 24 12C24 8.685 21.315 6 18 6ZM19.83 13.735C19.975 13.88 19.975 14.12 19.83 14.265C19.755 14.34 19.66 14.375 19.565 14.375C19.47 14.375 19.375 14.34 19.3 14.265L17.565 12.53L15.83 14.265C15.755 14.34 15.66 14.375 15.565 14.375C15.47 14.375 15.375 14.34 15.3 14.265C15.155 14.12 15.155 13.88 15.3 13.735L17.035 12L15.3 10.265C15.155 10.12 15.155 9.88 15.3 9.735C15.445 9.59 15.685 9.59 15.83 9.735L17.565 11.47L19.3 9.735C19.445 9.59 19.685 9.59 19.83 9.735C19.975 9.88 19.975 10.12 19.83 10.265L18.095 12L19.83 13.735ZM6 17.25C3.105 17.25 0.75 14.895 0.75 12C0.75 9.105 3.105 6.75 6 6.75H13.69L9.315 17.25H6.005H6ZM9.66 10.265L5.395 14.53L3.39 12.525C3.245 12.38 3.245 12.14 3.39 11.995C3.535 11.85 3.775 11.85 3.92 11.995L5.395 13.47L9.13 9.735C9.275 9.59 9.515 9.59 9.66 9.735C9.805 9.88 9.805 10.12 9.66 10.265Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCpra24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CPRA_24px.f6dc712cee0ece3f6083ed572ed63322.svg";